<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div class="realtimedashboard">
 <div class="header-custome flex flex-wrap items-center mb-4">
	<div class="flex-grow">
	 <h3>Real Time Dashboard</h3>
	</div>
	  <vs-dropdown vs-trigger-click class="cursor-pointer self-end reto-dp">
                <small
                  class="flex cursor-pointer justify-content-between"
                >
				<label class="m-0 flex-grow text-left flex items-center">
				<feather-icon
                    icon="CalendarIcon"
                    svgClasses="h-6 w-6"
                    class="mr-2"
                  />
                  <span>{{dashboardFilterVal == 365 ? 'All days' : `Last ${dashboardFilterVal} ${dayORmin}s`}}</span>
				  </label>
                  <feather-icon
                    icon="ChevronDownIcon"
                    svgClasses="h-6 w-6"
                    class="ml-3"
                  />
                </small>
                <vs-dropdown-menu class="dropdown-width">
                  <vs-dropdown-item @click="filterDashboard(365, 'day')">
                    <span>All Days</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="filterDashboard(30, 'day')">
                    <span>Last 30 Days</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="filterDashboard(7, 'day')">
                    <span>Last 7 Days</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="filterDashboard(60, 'min')">
                    <span>Last 60 Mins</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
	</div>
	
	<div class="vx-row" >
	<!-- left side start -->
	<div class="vx-col w-full lg:w-1/3 lg:mt-0 mt-base">
			<vx-card v-if="userCountSection">
			  <div slot="no-body" class="p-6 flex justify-center left-info-bg ">
			  <!-- total register user -->
				<div class="infocolor-box mouse-pointer" @click="getUsersList('getAllRegisteredUsers')">
					<h2 class="mb-1 font-bold mt-3">{{userCountSection.totRegCount}}</h2>
					<h4 class="mb-0  mb-3">Total registered users</h4>
				</div>
				<!-- total register user end-->
				<!-- logged in user start -->
				<div class="infocolor-box flex items-center mx-auto mouse-pointer" style="width:85%;background:rgba(0, 227, 150, 0.85) !important;" @click="getUsersList('getAllActiveUsers')">
					<div class="infocolor-box-left flex-grow py-3">
						<h2 class="mb-1 ">{{userCountSection.activeUsers.count}}</h2>
						<h4 class="mb-0 ">Logged-in users</h4>
					</div>
					<div class="infocolor-box-right">
						<h2 class="mb-1">{{userCountSection.activeUsers.percent}}%</h2>
					</div>
				</div>
				<!-- logged in user end-->
				<!-- logged in user start less than 40%-->
				<div class="flex items-center justify-center mouse-pointer" style="display:none !important" @click="getUsersList('getAllActiveUsers')">
					<div class=" flex items-center justify-center logged_in" style="width:14%">
						<h2 class="mb-1">{{userCountSection.activeUsers.percent}}%</h2>
					</div>
					<div class="infocolor-box-right pl-3">
						<h2 class="mb-1 font-600">{{userCountSection.activeUsers.count}}</h2>
						<h4 class="mb-0">Logged-in users</h4>
					</div>
				</div>
				<!-- logged in user less than 40% end-->
				<!-- Users in current sessions -->
				<div class="infocolor-box flex items-center mx-auto mouse-pointer" style="width:69%" @click="getUsersList('getCurrentSessionParticipants')">
					<div class="infocolor-box-left flex-grow">
						<h2 class="mb-1">{{userCountSection.engagements.session.current.userCount}}</h2>
						<h4 class="mb-0 ">Users in <br/>current session(s)</h4>
					</div>
					<div class="infocolor-box-right">
						<h2 class="mb-1">{{userCountSection.engagements.session.current.percent}}%</h2>
					</div>
				</div>
				<!-- Users in current sessions start less than 40%-->
				<div class="flex items-center justify-center mouse-pointer" style="display:none !important" @click="getUsersList('getCurrentSessionParticipants')">
					<div class="flex items-center justify-center  current_sessions" style="width:14%">
						<h2 class="mb-1">{{userCountSection.engagements.session.current.percent}}%</h2>
					</div>
					<div class="infocolor-box-right pl-3">
						<h2 class="mb-1 font-600">{{userCountSection.engagements.session.current.userCount}}</h2>
						<h4 class="mb-0">Users in <br/>current sessions</h4>
					</div>
				</div>
				<!-- Users in current sessions less than 40% end-->
				<!-- not register user-->
				<div class="infocolor-box flex items-center mx-auto not-logedin-user mouse-pointer" style="width:100%;background:rgba(254, 176, 25, 0.85) !important;" @click="getUsersList('getAllInactiveUsers')">
					<div class=" infocolor-box-left flex-grow">
						<h2 class="mb-1">{{userCountSection.inactiveUsers.count}}</h2>
						<h4 class="mb-0 ">Not logged-in users</h4>
					</div>
					<div class="infocolor-box-right">
						<h2 class="mb-1">{{userCountSection.inactiveUsers.percent}}%</h2>
					</div>
				</div>
				<!-- not register user-->
				<!-- not loged in user start less than 40%-->
				<div class="flex items-center justify-center not-logedin-user-wp mouse-pointer" style="display:none !important" @click="getUsersList('getAllInactiveUsers')">
					<div class="not-logedin-user flex items-center  justify-center mb-0" style="width:14%">
						<h2 class="mb-1">{{userCountSection.inactiveUsers.percent}}%</h2>
					</div>
					<div class="infocolor-box-right pl-3">
						<h2 class="mb-1 font-600">{{userCountSection.inactiveUsers.count}}</h2>
						<h4 class="mb-0">not logged in users</h4>
					</div>
				</div>
				<!-- not register user less than 40% end-->
			  </div>
			</vx-card>
		</div>
	<!-- left side end -->
	<!-- right side start -->
		<div class="vx-col w-full lg:w-8/12 lg:mt-0 mt-base mouse-pointer ">
			<vx-card title="User Engagement" class="usereng-f-ico">
			<!-- icon -->
			<span class="user-eng-ico"><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line x1="12" y1="17" x2="12.01" y2="17"></line></svg
          ></span>
			<!-- icon end-->
			<!--  <vs-dropdown vs-trigger-click class="cursor-pointer self-end ">
                <feather-icon
                    icon="MoreVerticalIcon"
                    svgClasses="h-4 w-4"
                    class="ml-1"
                  />
                <vs-dropdown-menu class="dropdown-width">
                  <vs-dropdown-item >
                    <span>All Days</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item >
                    <span>Last 30 Days</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item >
                    <span>Last 7 Days</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown> -->
		   
			  <div slot="no-body" class="p-6  pb-0 flex justify-center">
				<div id="chart">
					<apexchart type="pie" width="480" v-if="engagementSeries.length" :options="engagementchartOptions" :series="engagementSeries"></apexchart>
				  </div>
			  </div>
			</vx-card>
			<!---right inner start--->
			<div class="vx-row mt-base chart-bottom" >
			<!-- Users in 1:1 meeting start -->
			<div class="vx-col w-full lg:w-3/12 lg:mt-0 mt-base mouse-pointer">
			<vx-card class="p-2" v-if="userCountSection">
			  <div slot="no-body" class="p-6  ">
				  <feather-icon icon="UserCheckIcon" svgClasses="text-warning" class="p-3 inline-flex rounded-full" ::class="[`text-warning`, 'mb-4']" :style="{background: `rgba(var(--vs-warning),.15)`}"></feather-icon>
				  <h2 class="mt-6 font-600">{{userCountSection.engagements.meeting.current.userCount}}</h2>
				  <p>Users in 1:1 meeting</p>
					  
			  </div>
			</vx-card>
			</div>
			<!-- Users in 1:1 meeting end-->
			<!-- Users in roundtable  start -->
			<div class="vx-col w-full lg:w-3/12 lg:mt-0 mt-base mouse-pointer">
			<vx-card class="p-2" v-if="userCountSection">
			  <div slot="no-body" class="p-6  ">
			  <div class="p-3 inline-flex rounded-full bg_primary">
				  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24" viewBox="0 0 82 79.563">
  <path id="rt.svg"    d="M267.617,61.331l-6.209-1.748a35.138,35.138,0,0,0-.1-19.138l6.211-1.748A40.526,40.526,0,0,1,267.617,61.331ZM236.683,84.113a34.352,34.352,0,0,0,16.3-9.622l4.466,4.356a40.934,40.934,0,0,1-19.277,11.1Zm-0.089-67.875,1.488-5.847a40.93,40.93,0,0,1,19.181,10.941l-4.472,4.361A34.329,34.329,0,0,0,236.594,16.237ZM255,50a27,27,0,1,1-27-27A27,27,0,0,1,255,50ZM228,29.5A20.5,20.5,0,1,0,248.5,50,20.5,20.5,0,0,0,228,29.5ZM203.276,26l-4.484-4.373a40.932,40.932,0,0,1,19.145-11.16l1.491,5.858A34.363,34.363,0,0,0,203.276,26Zm16.065,58.018-1.489,5.846a40.95,40.95,0,0,1-19.24-11.318l4.48-4.368A34.383,34.383,0,0,0,219.341,84.019Zm-24.425-24.6-6.223,1.751a40.6,40.6,0,0,1,.1-22.318l6.225,1.752A35.17,35.17,0,0,0,194.916,59.422Z" transform="translate(-187.188 -10.375)"/>
</svg>
	</div>
				  <h2 class="mt-6 font-600">{{userCountSection.engagements.roundTable.current.userCount}}</h2>
				  <p>Users in roundtable</p>
					  
			  </div>
			</vx-card>
			</div>
			<!-- Users in roundtable end-->
			<!-- Users in roundtable  start -->
			<div class="vx-col w-full lg:w-6/12 lg:mt-0 mt-base mouse-pointer">
			<vx-card class="p-2">
			  <div slot="no-body" class="p-2">
			 
				  <h3 class="font-600">Device Access</h3>
				  <p>User engagement through Web, iOS and Android</p>
					  
      <!-- <div id="chart"> -->
        <apexchart type="bar" height="120" :options="deviceAccessOptions" :series="deviceAccessSeries"></apexchart>
      <!-- </div> -->
			  </div>
			</vx-card>
			</div>
			<!-- Users in roundtable end-->
			</div>
			<!--right inner end-->
		</div>
		<!-- right side end -->
	</div>
	<!----live session analytic start-->
	<div class="vx-row" >
		<div class="vx-col w-full lg:w-1/1  mt-base ">
		<vx-card class="livesession-analytic">
		 <div class="header-custome flex flex-wrap items-center p-5">
	<div class="flex-grow">
	 <h3>Live session Analytics</h3>
	</div>
	<div class="right-side flex ">
	<vs-input
          class="sm:mr-4 mr-2 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          placeholder="Search..."
        />
	 <vs-button  class="mr-4 btn-primary py-0" type="filled" @click="getMailTpls()">
	 <feather-icon icon="MailIcon"  class=" inline-flex rounded-full mr-2" ></feather-icon> Send Email</vs-button >
	 <vs-button  class="mr-4 btn-primary py-0" type="filled" @click="getNotification()">
	  <feather-icon icon="MessageSquareIcon"  class=" inline-flex rounded-full mr-2" ></feather-icon>
	 Send Push Notification</vs-button >
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-dropdown vs-trigger-click class="cursor-pointer ">
                <feather-icon
                    icon="MoreVerticalIcon"
                    svgClasses="h-4 w-4"
                    class="ml-1"
                  />
                <vs-dropdown-menu class="dropdown-width">
                  <vs-dropdown-item >
                    <span>All Days</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item >
                    <span>Last 30 Days</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item >
                    <span>Last 7 Days</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
	</div>
	</div>
	<!----body area start-->
	<div class="relative border-top" >
	 <vs-sidebar class="items-no-padding" id="chat-list-sidebar1" v-model="isChatSidebarActive">
                <div class="chat__chats-list px-4">
                    <div class="flex justify-content-between items-center">
                      <h5 class=" mb-4 pt-4">Select a session</h5>
                    </div>
                  <ul class="">
				  <li class='left-se-box p-4 mb-4' v-for="session in sessionList" @click="`${session.StreamingClient.includes('Zoom') ? '' : getSessionUsersActivity(session.SessionId)}`">				  	
				  <span class="flex items-center">
				  	<div class="h-3 w-3 rounded-full mr-1" :class="getSessionStatus(session.StartDate.seconds, session.EndDate.seconds).class"></div>
              <span>{{ getSessionStatus(session.StartDate.seconds, session.EndDate.seconds).status }}</span>
          </span>
          <vx-tooltip color="warning" v-if="session.StreamingClient.includes('Zoom')" text="Zoom Session Not acceptable" position="top" ><h4 class="mt-3">{{session.Name}}</h4></vx-tooltip>
					<h4 v-else class="mt-3">{{session.Name}}</h4>
				  <p>{{new Date(session.StartDate.seconds* 1000).toUTCString() | formatDate}} - {{new Date(session.EndDate.seconds* 1000).toUTCString() | formatDate }}</p>
				  </li>				  
				  </ul>
                </div>
           
        </vs-sidebar>
		 <div class="chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0 sidebar-spacer--wide" >
		<!-- table start -->
		<vs-table search stripe  :data="sessionUsers" class="user-table">
      
      <template slot="thead">
	   <vs-th>
         <div  class="custom-radios">
			<div  class="checkbox-hld">
				<input type="radio" name="" id="checkmark2" value="">
				<label for="checkmark2"><span class="checkmark"></span></label>
			</div>
			</div>
        </vs-th>
        <vs-th sort-key="email">
          USERS
        </vs-th>
        <vs-th sort-key="username">
          JOIN TIME
        </vs-th>
        <vs-th sort-key="id">
          CHAT
        </vs-th>
		<vs-th sort-key="id">
          QnA
        </vs-th>
		<vs-th sort-key="id">
          POLL
        </vs-th>
		<vs-th sort-key="id">
         &nbsp;
        </vs-th>
      </template>

      <template>
        <vs-tr :key="indextr" v-for="(tr, indextr) in sessionUsers" >
		<vs-td style="width: 20px;">
			<div  class="custom-radios">
			<div  class="checkbox-hld">
				<input type="radio" name="" id="checkmark1" value="">
				<label for="checkmark1"><span class="checkmark"></span></label>
			</div>
			</div>
          </vs-td>
          <vs-td>
			<div class="flex ">
				<!-- <img src="/@assets/images/user-avatar.png" alt="e2m" class="rounded-full h-10 w-10 mr-2"> -->
				<div class="t-right">
				<h5>{{tr.FirstName}} {{tr.LastName}}</h5>
				<p class="text-muted">{{tr.Email}}</p>
				</div>
			</div>
			
          </vs-td>

           <vs-td>
            <vs-chip v-for="time in tr.JLTIME">
            {{time.JoinTime ? new Date(time.JoinTime._seconds* 1000).toUTCString() : '' | formatDate}} 
            - {{time.LeaveTime ? new Date(time.LeaveTime._seconds* 1000).toUTCString() : '' | formatDate}}
          </vs-chip>
          </vs-td>

          <vs-td>
            {{tr.CHAT}}
          </vs-td>
		  <vs-td>
            {{tr.QNA}}
          </vs-td>
		   <vs-td>
            {{tr.POLL}}
          </vs-td>
		    <!-- <vs-td :data="data[indextr].id">
		   <vs-dropdown vs-trigger-click class="cursor-pointer self-end">
                <feather-icon
                    icon="MoreVerticalIcon"
                    svgClasses="h-4 w-4"
                    class="ml-1"
                  />
                <vs-dropdown-menu class="dropdown-width">
                  <vs-dropdown-item >
                    <span>All Days</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item >
                    <span>Last 30 Days</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item >
                    <span>Last 7 Days</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
          </vs-td> -->
        </vs-tr>
      </template>


    </vs-table>
		<!-- table end -->
		 </div>
	</div>
	<!----body area end-->
		</vx-card >
		</div>
	</div>
	<!----live session analytic end-->
	<!-- mail send popup start-->
	<vs-popup
    mailpopup
    class="holamundo customnewpopup"
    title="Mail Preview"
    :active.sync="popupActiveMail"
  >
    <div class="vx-col md:w-1/1 w-full mt-4">
      <label>Choose Template</label>
      <v-select :clearable="false" label="DisplayLabel" v-model="selectedMailPath" :options="mailtplData" @input="getMailTpl" />
      <div class="mail-template-switch-btn">
        <!-- <ul>
          <li
            id="reminderTemp"
            class="active"
            @click="setPreviewMailTemplate('Reminder')"
          >
            Reminder
          </li>
          <li
            id="announcementTemp"
            @click="setPreviewMailTemplate('Announcement')"
          >
            Announcement
          </li>
        </ul> -->
      </div>
    </div>
    <vs-tabs>
      <vs-tab label="Preview">
                <div class="tab-text">
                  <div class="vx-row" style="width: 622px">
                    <div class="vx-col md:w-1/1 w-full mt-4 email-temp-head">
                      <h3>Subject: {{ MailSubject }}</h3>
                    </div>
                    <br />
                    <div v-html="MailHtml"></div>
                    <br />
                    <div class="vx-col md:w-1/1 w-full mt-4">
                      <div click="sendbtn-section">
                        <vs-button color="rgb(76, 139, 246)" type="filled" @click="cancelMail"
                          >Cancel</vs-button
                        >
                        <vs-button
                          class="mail-btn"
                          color="rgb(76, 139, 246)" type="filled"
                          @click="sendMail"
                          >Send Mail</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </vs-tab>
              <vs-tab label="Edit">
                <div class="tab-text">
                  <div class="vx-row" style="width: 622px;">
                    <div class="vx-col md:w-1/1 w-full mt-4">
                      Subject:
                      <vs-input
                        class="inputx w-full mt-4"
                        v-model="MailSubject"
                        v-validate="'required'"
                        name="Subject"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('Subject')"
                        >{{ errors.first("Subject") }}</span
                      >
                      <br />Body:                      
                      <ckeditor
                        class="desc-event"
                        v-model="MailHtml"
                        :config="editorConfig"
                      ></ckeditor>
                      <br />
                      <div click="sendbtn-section">
                        <vs-button color="rgb(76, 139, 246)" type="filled" @click="cancelMail"
                          >Cancel</vs-button
                        >
                        <vs-button
                          class="mail-btn"
                          color="rgb(76, 139, 246)" type="filled"
                          @click="before_save"
                          >Save</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </vs-tab>
    </vs-tabs>
  </vs-popup>
	<vs-popup class="holamundo customnewpopup" title="Send Instant Notification" :active.sync="popupNotification">
		<form @submit.prevent="validateForm('form-notification')" data-vv-scope="form-notification">
			<div class="vx-row w-630">
			    <div class="vx-col md:w-1/1 w-full">
			    	<label>Notification Title <span class="text-danger">*</span></label>
			    	<vs-input
	                  class="mt-5 w-full"
	                  name="NotificationName"
	                  v-model="NotificationName"
	                  data-vv-as="Notification Name"
	                  v-validate="'required'"
	                />
	                <span
	                  class="text-danger text-sm"
	                  v-show="errors.has('form-notification.NotificationName')"
	                  >This field is required</span
	                >
			    </div>
			    <div class="vx-col md:w-1/1 w-full mt-5">
			    	<label>Notification Message <span class="text-danger">*</span></label>
	                <vs-textarea
	                  class="w-full"
	                  name="NotificationMessage"
	                  v-model="NotificationMessage"
	                  data-vv-as="Notification Message"
	                  v-validate="'required'"
	                />
	                <span
	                  class="text-danger text-sm"
	                  v-show="errors.has('form-notification.NotificationMessage')"
	                  >This field is required</span
	                >
			    </div>
			    <div class="vx-col md:w-1/1 w-full mt-5 mb-5">
	                <label>Deep Link </label>
	                <v-select
	                  class="w-full select-large"
	                  v-model="DeepLink"
	                  :options="landingURLOptions"
	                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
	                />
	            </div>
	            <div class="vx-col md:w-1/1 w-full mt-5 flex justify-center">
	                <vs-button
			            color="success"
			            type="filled"
			            class="mr-3"
			            @click="before_save_notification()"
			        >SUBMIT</vs-button>
	            </div>
			</div>
		</form>
	</vs-popup>
	<!-- mail send popup end-->
	<vs-popup
      class="holamundo userlist-popup"
      :title="`${usersList.length} ${popupUsersListTitle}`"
      :active.sync="popupUsersList"
    >
      <div
        class="
          vx-col
          flex
          justify-between
          items-center
          w-full
          text-right
          mb-5
          event-admin-popup-header
        "
      >
        <vs-button icon="mail" @click="getMailTpls()">Send Mail To Selected Users</vs-button>
        <vs-button icon="notifications" @click="getNotification()">Send Notification To All Attendee</vs-button>        
      </div>
      <div class="flex flex-wrap">
        <div class="flex-grow">
          <div>
            <vs-table :data="usersList">
              <template slot="thead">
              	<vs-th>{{selectedUsersList.length}} Selected</vs-th>
                <vs-th>User Id</vs-th>
                <vs-th>Name</vs-th>
                <vs-th>Email</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                	<vs-td>
                    <vs-checkbox
                      v-model="selectedUsersList"
                      :vs-value="tr"
                    />
                  </vs-td>
                  <vs-td>{{tr.id}}</vs-td>                  
                  <vs-td>{{tr.name}}</vs-td>                  
                  <vs-td>{{tr.email}}</vs-td>                  
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </vs-popup>
</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { AgGridVue } from "ag-grid-vue";
import vSelect from "vue-select";
import moment from "moment-timezone";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";
import moduleDashboardManagement from "@/store/dashboard/moduleDashboard.js";
import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleNotificationManagement from "@/store/notification-management/moduleNotificationManagement.js";
import moduleMailtplManagement from "@/store/mailtpl-management/moduleMailtplManagement.js";
import ls from "@/common/localStorage";
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
var vm;
export default {
  components: {
    apexchart: VueApexCharts,
	  AgGridVue,
	  vSelect,
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      editorConfig: CKconfig.editorConfig,
      dashboardFilterVal: 365,
      dayORmin: 'day',
      engagementSeries: [],
      engagementchartOptions: {
        chart: {
          width: 780,
          type: 'pie',
        },
        labels: ['Expo', 'Lobby', 'Current Session', 'Multi Session', 'Roundtable','Sponsors','1:1 Meeting','Unknown'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 400
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
			},
			deviceAccessOptions:{
				chart: {
          type: 'bar',
          stacked: true,
          toolbar: {
	        	show: false
	        },
        },        
        plotOptions: {
          bar: {
            horizontal: true,
            //barHeight: '10%'
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        legend: {
        	show: true,
          position: 'bottom',
          horizontalAlign: 'left',
          //offsetX: 40
        },
        xaxis: {
        	labels: {
        		show: false,
        	},
        	axisBorder: {
        		show: false,
        	},
        	axisTicks: {
        		show: false,
        	}
        },
        yaxis: {
        	labels: {
        		show: false,
        	},
        	axisBorder: {
        		show: false,
        	},
        	axisTicks: {
        		show: false,
        	}
        }
			},
			deviceAccessSeries: [],
			mailRecepients: [],
      selectedMailPath: null,
      MailHtml: null,
      MailSubject: null,
      userType: null,
			sessionList: [],
			sessionUsers: [],
			isChatSidebarActive  : true,	
			popupActiveMail: false,
			userCountSection: null,
			popupNotification: false,
			NotificationName: "",
	    NotificationMessage: "",
	    DeepLink: null,
	    landingURLOptions: [
	        "/lobby",
	        "/sessions",
	        "/livestage",
	        "/attendee",
	        "/exhibitorshall",
	        "/mymeetings",
	        "/myprofile",
	    ],
	    usersList: [],
	    selectedUsersList: [],
			popupUsersList: false,
			popupUsersListTitle: "Users List"
    }
	
  },
  computed: {
  	mailtplData() {
      if(this.Environment != 'EDU')
        return this.$store.state.mailtplManagement.mailtpls.filter(item=> ['AnnouncementMail', 'ReminderMail', 'Custom'].includes(item.CollectionName));
      else
        return this.$store.state.mailtplManagement.mailtpls.filter(item=> ['ReminderMail'].includes(item.CollectionName));
    },
  },
  filters:{
  	formatDate: function(val){
      if (!val) return ''
      return moment(val).format("MMM DD, YYYY hh:mm A")      
    },
  },
  methods: {  	
  	getUsersList(usersType){
  		this.selectedUsersList = [];
  		if(usersType == "getAllRegisteredUsers")
				this.popupUsersListTitle = "Registered Users";
			else if(usersType == "getAllActiveUsers")
				this.popupUsersListTitle = "Active Users";
			else if(usersType == "getAllInactiveUsers")
				this.popupUsersListTitle = "Inactive Users";
			else if(usersType == "getCurrentSessionParticipants")
				this.popupUsersListTitle = "Current Session Participants";
			else
				this.popupUsersListTitle = "Users List"
			this.$vs.loading();
			let dashboardFilterVal = this.dashboardFilterVal;
			if(this.dayORmin == 'day')
				dashboardFilterVal = dashboardFilterVal*24;
			else
				dashboardFilterVal = dashboardFilterVal/60;
			this.$store.dispatch(`dashboardManagement/${usersType}`, dashboardFilterVal).then(res=>{
				this.$vs.loading.close();
				this.usersList = res;				
				this.popupUsersList = true;
			}).catch(err=>{
				this.$vs.loading.close();
				this.$vs.notify({
  				position: 'top-center',
          color: "warning",
          text: "Something went wrong!",
        });
			})
  	},
  	getNotification(){
  		this.popupNotification = true;
  	},
  	before_save_notification(){
  		this.$validator.validateAll("form-notification").then((result) => {
	        if (result) {
	        	this.saveNotification();
	        }
	     });
  	},
  	saveNotification(){
  		//if(this.selectedUsersList.length){
  			this.$vs.loading();
  			let data = {
  				NotificationName: this.NotificationName,
					NotificationMessage: this.NotificationMessage,
					DeepLink: this.DeepLink
					//selectedUsersList: this.selectedUsersList
  			}
      	this.$store.dispatch("NotificationManagement/sendNotificationToAllAttendee", data).then(res=>{
      			this.popupNotification = false;
      			this.NotificationName = null;
						this.NotificationMessage = null;
						this.DeepLink = null;
		      			this.$vs.loading.close();
		      			this.$vs.notify({
		      				position: 'top-center',
				            color: "success",
				            //title: "Notification",
				            text: "Notification sent successfully.",
				          });
		      		}).catch(err=>{
		      			console.log(err)
		      			this.$vs.loading.close();
		      			this.$vs.notify({
		      				position: 'top-center',
				            color: "warning",
				            //title: "Notification",
				            text: "Something went wrong!",
				          });
		      		})
      	//}
      	/*else {
	      this.popupUsersList = false;
	      this.popupNotification = false;
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please Select Recepient! ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }*/

  	},
		async getMailTpls(){
      this.$vs.loading(); 
      this.MailHtml = null;
      this.MailSubject = null;
      this.selectedMailPath = null;
      await this.$store.dispatch("mailtplManagement/fetchMailtpls");
      this.popupActiveMail = true;
      this.$vs.loading.close();   
    },
    getMailTpl() {
      this.$vs.loading();      
      this.MailHtml = "Loading...";
      this.$store
        .dispatch("attendeeManagement/getMailTemplate", this.selectedMailPath)
        .then((res) => {
          this.MailHtml = res.html;
          this.MailSubject = res.subject;
          this.$vs.loading.close();          
        });
    },
		before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.saveMail();
        }
      });
    },
    saveMail() {
      if(this.selectedMailPath && this.MailSubject){
        this.$vs.loading();
        this.$store
          .dispatch("attendeeManagement/saveMail", {
            html: this.MailHtml,
            subject: this.MailSubject,
            tplpath: this.selectedMailPath,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              title: "Mail Saved",
              text: res.message,
            });
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      }else{
        this.$vs.notify({
          position: "top-center",
          color: "warning",
          text: "Template and Subject mandatory! "
        });
      }
    },
    sendMail() {
      let selectedRows = this.selectedUsersList;
      if (selectedRows.length > 400) {
        this.$vs.notify({
          //type: "alert",
          position: "top-center",
          color: "warning",
          //title: "Status",
          text: "Mail cannot be sent more than 400 attendee at a time!",
          //acceptText: "OK",
        });
        return false;
      }
      selectedRows.map((row) => {
        //console.log(row);
        this.mailRecepients.push(row.id);
      });
      if (this.mailRecepients.length && this.MailSubject) {
        this.$vs.loading();
        this.$store
          .dispatch("attendeeManagement/sendMail", {
            data: this.mailRecepients,
            subject: this.MailSubject,
            tplpath: this.selectedMailPath,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              position: 'top-center',
              color: "success",
              title: "Mail Sent",
              text: res.message,
            });
            this.mailRecepients = [];
            this.gridApi.deselectAll();
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          color: "warning",
          //title: "Mail Sent",
          text: "Please select recipient!",
        });
      }
      this.popupActiveMail = false;
    },    
		cancelMail() {
      this.popupActiveMail = false;
      this.previewSelectedTemplate = "Reminder";
        var element2 = document.getElementById("reminderTemp");
        element2.classList.add("active");
        var element = document.getElementById("announcementTemp");
        element.classList.remove("active");
    },
    setPreviewMailTemplate(template) {
      if (template == "Reminder") {
        this.previewSelectedTemplate = "Reminder";
        var element2 = document.getElementById("reminderTemp");
        element2.classList.add("active");
        var element = document.getElementById("announcementTemp");
        element.classList.remove("active");
        this.getMailTpl();
      } else {
        this.previewSelectedTemplate = "Announcement";
        var element2 = document.getElementById("reminderTemp");
        element2.classList.remove("active");
        var element = document.getElementById("announcementTemp");
        element.classList.add("active");
        this.getAnnouncementMailTpl();
      }
    },
    getAnnouncementMailTpl() {
      let selectedRows = this.selectedUsersList;
      if (selectedRows.length > 400) {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          //title: "Status",
          text: "Mail cannot be sent more than 400 attendee at a time!",
          acceptText: "OK",
        });
      } else if(selectedRows.length) {
        this.$vs.loading();
        this.welcomeMailText = "Loading...";
        this.$store
          .dispatch("attendeeManagement/getAnnouncementMailTemplate")
          .then((res) => {
            this.welcomeMailText = res.html;
            this.welcomeMailSubject = res.subject;
            this.sourcehtml = res.sourcehtml;
            this.$vs.loading.close();
            this.popupActiveMail = true;
          });
      }else{
      	this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          //title: "Status",
          text: "No users to send mail!",
          acceptText: "OK",
        });
      }
    },
		getSessionStatus(startsec, endsec){
			let startmin = startsec * 1000;
			let endmin = endsec * 1000;
  		if(endmin < new Date().getTime())
  			return {status: 'Past', class: 'bg-secondary'}
  		else if(startmin > new Date().getTime())
  			return {status: 'Upcoming', class: 'bg-warning'}
  		else if(startmin <= new Date().getTime() && endmin >= new Date().getTime())
  			return {status: 'Live', class: 'bg-success'}
  		else
  			return {status: '', class: 'bg-secondary'};
  	},
		filterDashboard(filterval, dayORmin){
			this.dashboardFilterVal = filterval;
			this.dayORmin = dayORmin;
			this.getTurnoutCounts();
		},
		getTurnoutCounts(){
			this.$vs.loading();
			let dashboardFilterVal = this.dashboardFilterVal;
			if(this.dayORmin == 'day')
				dashboardFilterVal = dashboardFilterVal*24;
			else
				dashboardFilterVal = dashboardFilterVal/60;
      this.$store.dispatch("dashboardManagement/getTurnoutCounts", dashboardFilterVal).then(res=>{
      	this.$vs.loading.close();
      	this.userCountSection = res;
      	this.engagementSeries = [
	      	res.engagements.expo.userCount, 
	      	res.engagements.lobby.userCount, 
	      	res.engagements.session.current.userCount, 
	      	res.engagements.session.all.userCount, 
	      	res.engagements.roundTable.all.userCount, 
	      	res.engagements.sponsor.userCount, 
	      	res.engagements.meeting.all.userCount, 
	      	res.engagements.others.userCount
      	]

      	this.deviceAccessSeries = res.appPlatformUsage.map(item=>{
      		return {name: item.appType, data:[item.userCount]}
      	})
      	//this.deviceAccessSeries.push({name:'', data:[]})
      });
		},
		getSessions(){
			this.$store.dispatch("sessionManagement/fetchSessions").then(res=>{
				this.sessionList = res;
			})
		},
		getSessionUsersActivity(SessionId){
			this.$vs.loading();
			this.sessionUsers = [];
			this.$store.dispatch("sessionManagement/getSessionUsersActivity", SessionId).then(res=>{
				this.$vs.loading.close();
				this.sessionUsers = res;
			}).catch(_=>{ 
				this.$vs.loading.close();
				this.$vs.notify({
          position: 'top-center',
          color: "warning",
          text: "Something went wrong!",
        });
			})
		}
  },
  mounted(){
  	
  },
  created(){
  	vm = this;
  	if (!moduleDashboardManagement.isRegistered) {
      this.$store.registerModule(
        "dashboardManagement",
        moduleDashboardManagement
      );
      moduleDashboardManagement.isRegistered = true;      
    }
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    }    
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule("attendeeManagement", moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
    if (!moduleNotificationManagement.isRegistered) {
      this.$store.registerModule("NotificationManagement", moduleNotificationManagement);
      moduleNotificationManagement.isRegistered = true;
    }
    if (!moduleMailtplManagement.isRegistered) {
      this.$store.registerModule("mailtplManagement", moduleMailtplManagement);
      moduleMailtplManagement.isRegistered = true;
    }
    this.getTurnoutCounts();
    this.getSessions();
    
  }
}
</script>

<style>


	
.bg_primary{background-color:rgba(76,139,246,0.15)}
.bg_primary svg path{fill:#7367f0!important}




</style>
